import { Injectable, computed } from '@angular/core';

import { Observable, from } from 'rxjs';

import { Asesor, BasicObjectSMI } from '@interfaces/index';
import { ConsumirApi } from '@utils/index';

@Injectable({
  providedIn: 'root'
})
export class AsesorService {

  private controlador = computed(() => 'asesor');
  private api = new ConsumirApi(this.controlador());

  constructor() {}

  public obtenerTodos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`${idEmpresa}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/${idEmpresa}`);
  }

  public obtenerPorId(idEmpresa:number, id: number): Observable<Asesor>{
    return from(this.api.get<Asesor>(`${idEmpresa}/${id}`));
    // return this.http.get<asesorDTO>(`${this.apiURL}/${idEmpresa}/${id}`);
  }

  public crear(registro:Asesor){
    return from(this.api.post<Asesor, boolean>(``, registro));
    // return this.http.post(this.apiURL, registro);
  }

  public validarNombre(registro:Asesor){
    return from(this.api.post<Asesor, boolean>(`validarNombre`, registro));
    // return this.http.post(`${this.apiURL}/validarNombre`, registro);
  }

  public editar(id: number, registro:Asesor){
    return from(this.api.put<Asesor, boolean>(`${id}`, registro));
    // return this.http.put(`${this.apiURL}/${id}`, registro);
  }

  public borrar(id:number){
    return from(this.api.delete(`${id}`));
    // return this.http.delete(`${this.apiURL}/${id}`);
  }
}